import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";

const Jumbotron = ({ client, addStyle = {}, title = "" }) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const { i18n, t } = useTranslation();

  return (
    <div
      className="jumbotron rounded-0 mb-0 dashboard__jumbotron-container"
      style={addStyle}
    >
      <h4 className="text-brand">{title ? `${title}` : `${t('Hey')}, ${user.full_name}`}</h4>
      <p className="lead">{moment().format("dddd, DD MMMM YYYY")}</p>
    </div>
  );
};

export default Jumbotron;

// import React from "react";
// import moment from "moment";

// const Jumbotron = ({ greeting, client }) => {
//   const user = JSON.parse(localStorage.getItem("user"));

//   return (
//     <div
//       className={
//         client && !client.enable_smart_scheduler
//           ? "jumbotron rounded-0 mb-0  dashboard-jumbo-2"
//           : "jumbotron rounded-0 mb-0  dashboard-jumbo"
//       }
//     >
//       <h3>{greeting(moment())},</h3>
//       <h3 className="mb-4">{user.full_name}</h3>
//       <p className="lead">{moment().format("ddd, DD MMMM YYYY")}</p>
//     </div>
//   );
// };

// export default Jumbotron;
